var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOurStory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 3.41V16.77H9.14C9.51642 16.77 9.88915 16.8443 10.2368 16.9887C10.5844 17.133 10.9002 17.3446 11.1659 17.6112C11.4316 17.8778 11.642 18.1943 11.7852 18.5425C11.9283 18.8906 12.0013 19.2636 12 19.64V6.27C12 5.89442 11.926 5.52252 11.7823 5.17553C11.6386 4.82854 11.4279 4.51325 11.1623 4.24768C10.8968 3.9821 10.5815 3.77144 10.2345 3.62771C9.88748 3.48398 9.51558 3.41 9.14 3.41H1.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 3.41V16.77H14.86C14.4836 16.77 14.1109 16.8443 13.7632 16.9887C13.4156 17.133 13.0998 17.3446 12.8341 17.6112C12.5684 17.8778 12.358 18.1943 12.2148 18.5425C12.0717 18.8906 11.9987 19.2636 12 19.64V6.27C12 5.51148 12.3013 4.78403 12.8377 4.24768C13.374 3.71132 14.1015 3.41 14.86 3.41H22.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 16.77V20.59H14.86H9.14H1.5V16.77",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurStory);
export default __webpack_public_path__ + "static/media/our-story.ce8b2944dc6970eed21ad0b360494601.svg";
export { ForwardRef as ReactComponent };